import { persistStore } from "redux-persist";
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

import rootReducer from "./store/reducers/rootReducer";
import { APP_STORE, ENV_PROD_MODE } from "./config/constants";


const store = configureStore({
    // eslint-disable-next-line no-undef
    devTools  : process.env.REACT_APP_ENV !== ENV_PROD_MODE,
    reducer   : persistReducer({key: APP_STORE, storage},rootReducer),
  });


const persistor = persistStore(store);

export { store, persistor };    